export function formatCurrency(amount, currency) {
	if (typeof amount !== "number" || (currency !== "GTQ" && currency !== "USD")) {
		return "";
	}

	// Determinar el símbolo de la moneda
	const symbol = currency === "GTQ" ? "Q" : "$";

	// Formatear el número
	const formattedAmount = amount.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	// Devolver el texto formateado
	return `${symbol} ${formattedAmount}`;
}

export const formatShownDate = (dateString) => {
	const date = new Date(dateString);
	const options = {
		day: "2-digit",
		month: "short",
		year: "2-digit",
	};
	const newDate = date.toLocaleDateString("es-ES", options);
	return newDate;
};